export default __webpack_public_path__ + "static/media/right.785cbd38.png";